import React from "react";
import { Link } from "react-router-dom";
import HtmlContent, { PhotoLink } from "./HtmlContent";
import { sectionBlocks, useSiteData } from "../lib/siteApi";
import { prettyCountry } from "../lib/catalog";
import { orderProjectsForHome, projectHeadline, projectPhoto } from "../lib/projectPhotos";
import { blogData } from "../data/data";

export default function Blogs(){
    const site = useSiteData();
    const intro = sectionBlocks(site.content, "projects")[0];
    const projects = orderProjectsForHome(site.projects || []).slice(0, 4);
    const cards = projects.length
      ? projects.map((p) => ({
          id: p.id,
          title: projectHeadline(p),
          image: projectPhoto(p) || blogData[0]?.image,
          location: [prettyCountry(p.country), p.location, p.capacity].filter(Boolean).join(" · "),
        }))
      : blogData;

    return(
        <section className="relative py-16 lg:py-24 bg-white dark:bg-slate-900" id="blog">
            <div className="container relative">
                <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 dark:bg-teal-900/20 rounded-full border border-teal-200 dark:border-teal-800 mb-4">
                        <span className="renerg-kicker text-teal-600 dark:text-teal-400">OUR WORK</span>
                    </div>
                    <h2 className="renerg-section text-slate-900 dark:text-white mb-4">
                        <Link to="/projects" className="hover:text-teal-700">{intro?.title || "Completed project highlights"}</Link>
                    </h2>
                    <div className="renerg-body text-slate-600 dark:text-slate-400">
                        {intro?.body ? (
                          <HtmlContent html={intro.body} imageTo="/projects" />
                        ) : (
                          <p>Selected plants and photos from Rwanda, Kenya and Tchad. Open a project for the full story, or filter by country on the projects page.</p>
                        )}
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
                    {cards.map((item, index) => {
                        const to = item.id ? `/projects/${item.id}` : "/projects";
                        return(
                            <div className="group relative overflow-hidden" key={`${item.id || item.title}-${index}`}>
                                {item.image ? (
                                <PhotoLink to={to} src={item.image} alt={item.title} className="w-full h-60 object-cover group-hover:scale-110 transition-transform duration-500 ease-out" wrapClassName="rounded-2xl shadow-lg dark:shadow-gray-800 group-hover:shadow-xl transition-all duration-500 bg-slate-100">
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                </PhotoLink>
                                ) : (
                                  <Link to={to} className="block w-full h-60 rounded-2xl bg-gradient-to-br from-teal-600 to-emerald-700" />
                                )}
                                <div className="mt-5">
                                    <Link to={to} className="project-card-title text-slate-900 dark:text-white hover:text-teal-600 transition-colors duration-300 block">{item.title}</Link>
                                    {item.location ? <p className="project-kicker mt-2 text-slate-500">{item.location}</p> : null}
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="mt-10 text-center">
                  <Link to="/projects" className="inline-flex rounded-xl bg-teal-600 px-6 py-3 font-semibold text-white shadow-lg">See all projects →</Link>
                </div>
            </div>
        </section>
    );
}
